export default class PoliticaDSR {
    constructor() {
        this.id = null;
        this.descricao = null;
        // 1 no mesmo mês, 2 no mês posterior
        this.perdaDSRDesconta = null;
        // 1 domingos, 2 folgas
        this.pagarDSR = null;
        // 1 domingo, 2 feriado e domingo
        this.descontoDSR = null;        
    }    
}